import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { trackEvent } from '../utils/analytics';
import { AFFILIATION_EN, AFFILIATION_ES, AGENT_DISPLAY_NAME, AGENT_ROLE_EN, AGENT_ROLE_ES, BRAND_ASSETS_AUTHORIZED, BROKERAGE_WEBSITE_URL, BUSINESS_EMAIL, BUSINESS_EMAIL_HREF, BUSINESS_PHONE_DISPLAY, BUSINESS_PHONE_HREF, LOGO_AVANTI_WHITE, OFFICIAL_LISTING_URL, PROPERTY_ADDRESS } from '../data/contact';
export function Footer() {
  const {
    lang,
    t
  } = useLanguage();
  const year = new Date().getFullYear();
  return <footer className="w-full bg-midnight pb-28 pt-20 md:pb-16" data-id="element-189" data-mp="3ldu3ws48ejvt">
      <div className="mx-auto max-w-editorial px-5 lg:px-8" data-id="element-190" data-mp="3qcnkwuiq8t0q">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-191" data-mp="3qf9suv9j5ajh">
          <div className="lg:col-span-5" data-id="element-192" data-mp="29xlz0k1buwgz">
            <p className="font-display text-2xl uppercase tracking-[0.28em] text-white" data-id="element-193" data-mp="2eya1c1v0azqi">VERO</p>
            <h2 className="mt-6 font-display text-[24px] font-medium uppercase tracking-[0.05em] text-white" data-id="element-194" data-mp="3l9k65dxrvpdt">
              {AGENT_DISPLAY_NAME}
            </h2>
            <p className="label-caps mt-2 text-white/65" data-id="element-195" data-mp="3gc0hrl7d1w85">
              {lang === 'en' ? AGENT_ROLE_EN : AGENT_ROLE_ES}
            </p>
            <p className="label-caps mt-1 text-gold" data-id="element-196" data-mp="3q8mypywkg34w">
              {lang === 'en' ? AFFILIATION_EN : AFFILIATION_ES}
            </p>
            {BRAND_ASSETS_AUTHORIZED && <img src={LOGO_AVANTI_WHITE} alt="Avanti Way Realty LLC." className="mt-5 h-auto w-[155px]" width={155} height={31} loading="lazy" decoding="async" data-id="element-197" data-mp="80xjc6sbqxik" />}
          </div>

          <div className="lg:col-span-4" data-id="element-198" data-mp="qthx0gzgcw1s">
            <p className="label-caps text-white/50" data-id="element-199" data-mp="qujjriptz6zc">{t('Contact', 'Contacto')}</p>
            <div className="gold-rule mt-4 w-16" data-id="element-200" data-mp="msg56l7v7m9u" />
            <ul className="mt-5 space-y-3 text-[14px] text-white/80" data-id="element-201" data-mp="mptp1x6wryg0">
              <li data-id="element-202" data-mp="twfohubaxxsf">
                {t('Business phone', 'Teléfono')}:{' '}
                <a href={BUSINESS_PHONE_HREF} onClick={() => trackEvent('phone_click', {
                location: 'footer'
              })} className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-203" data-mp="yto5vsomlxsm">
                  {BUSINESS_PHONE_DISPLAY}
                </a>
              </li>
              <li data-id="element-204" data-mp="1cl2se9hqsh4f">
                {t('Business email', 'Correo')}:{' '}
                <a href={BUSINESS_EMAIL_HREF} onClick={() => trackEvent('email_click', {
                location: 'footer'
              })} className="break-all transition-colors duration-150 ease-out hover:text-gold" data-id="element-205" data-mp="1hjw4pylam230">
                  {BUSINESS_EMAIL}
                </a>
              </li>
              <li data-id="element-206" data-mp="3oczof8dimd4z">
                {t('Property', 'Propiedad')}: {PROPERTY_ADDRESS}
              </li>
            </ul>
            <p className="mt-4 text-[11px] text-white/55" data-id="element-207" data-mp="3tc2v0x958rf2">Avanti Way Realty LLC</p>
          </div>

          <nav aria-label={t('Legal', 'Legal')} className="lg:col-span-3" data-id="element-208" data-mp="2agyfna1uv5qc">
            <p className="label-caps text-white/50" data-id="element-209" data-mp="25n3x49xzkwsu">{t('Information', 'Información')}</p>
            <div className="gold-rule mt-4 w-16" data-id="element-210" data-mp="21nbl1n9dw8iq" />
            <ul className="mt-5 space-y-3 text-[13px] text-white/75" data-id="element-211" data-mp="1wnyyl3mfd3go">
              <li data-id="element-212" data-mp="1wlma07m5vuun">
                <Link to="/privacy-policy" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-213" data-mp="2tdziopbumvrn">
                  {t('Privacy Policy', 'Política de Privacidad')}
                </Link>
              </li>
              <li data-id="element-214" data-mp="2kcrx97uflpez">
                <Link to="/terms-of-use" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-215" data-mp="2kc8ig002vh56">
                  {t('Terms of Use', 'Términos de Uso')}
                </Link>
              </li>
              <li data-id="element-216" data-mp="18yxlh32nd452">
                <Link to="/accessibility" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-217" data-mp="18zfsmuqul2rr">
                  {t('Accessibility Statement', 'Declaración de Accesibilidad')}
                </Link>
              </li>
              <li data-id="element-218" data-mp="2wm7ll1axoe2r">
                <a href={OFFICIAL_LISTING_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('official_listing_click', {
                location: 'footer'
              })} className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-219" data-mp="2wmppmk3u7wl8">
                  {t('Official Brokerage Listing', 'Publicación Oficial')}
                </a>
              </li>
              <li data-id="element-220" data-mp="3fj7nlj9a4spx">
                <a href={BROKERAGE_WEBSITE_URL} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-221" data-mp="31lj2qbf7plkv">
                  {t('Official Avanti Way Website', 'Sitio Oficial de Avanti Way')}
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="gold-rule mt-14" data-id="element-222" data-mp="1nlfzbll4vssu" />

        <div className="mt-8 flex items-start gap-3" data-id="element-223" data-mp="1nk4lesxz54o0">
          <HomeIcon className="mt-0.5 h-5 w-5 shrink-0 text-white/70" aria-hidden="true" data-id="element-224" data-mp="1ine7ab5qcj58" />
          <p className="text-[12px] leading-relaxed text-white/65" data-id="element-225" data-mp="1wmdy9pgpta4k">
            {t('Equal Housing Opportunity. This property is offered without respect to race, color, religion, sex, handicap, familial status, national origin or any other protected class.', 'Igualdad de Oportunidades en la Vivienda. Esta propiedad se ofrece sin distinción de raza, color, religión, sexo, discapacidad, estado familiar, origen nacional o cualquier otra clase protegida.')}
          </p>
        </div>

        <p className="mt-6 max-w-4xl text-[12px] leading-relaxed text-white/55" data-id="element-226" data-mp="18w0awc92rzgb">
          {t('Property information is believed to be accurate but is not guaranteed and is subject to change. Buyers should independently verify property details, measurements, community restrictions, fees, rental eligibility and all information material to their purchase decision.', 'Se considera que la información de la propiedad es correcta, pero no está garantizada y está sujeta a cambios. Los compradores deben verificar independientemente las características, medidas, restricciones de la comunidad, tarifas, elegibilidad para alquiler y cualquier información relevante para su decisión de compra.')}
        </p>

        <p className="mt-5 max-w-4xl text-[12px] leading-relaxed text-white/55" data-id="element-227" data-mp="1xdvqlx4wvfyb">
          {t('This independently managed website promotes a property represented by Veronica Gomez Santana, a real-estate professional affiliated with Avanti Way Realty LLC. This is not the official corporate website of Avanti Way Realty LLC.', 'Este sitio administrado de manera independiente promociona una propiedad representada por Veronica Gomez Santana, profesional inmobiliaria afiliada a Avanti Way Realty LLC. Este no es el sitio corporativo oficial de Avanti Way Realty LLC.')}
        </p>

        <p className="mt-8 text-[11px] uppercase tracking-[0.14em] text-white/40" data-id="element-228" data-mp="171r3ykeiqrul">
          © {year} verogrealtor.com — {t('All rights reserved', 'Todos los derechos reservados')}
        </p>
      </div>
    </footer>;
}